import { Button, Col, Row } from "react-bootstrap"
import { BlockType } from "shared/types/science35Types"
import { useParams } from "react-router-dom"
import { toBlockType } from "helpers/blockStringConverter"
import { TextbookProductType } from "shared/types/curriculumTypes"

const sci68GuideLink = "https://drive.google.com/file/d/1-SACFfjGmikI4KFOcCkfyRjqpbNDtuiR/view?usp=sharing"
const sci2135GuideLink = "https://drive.google.com/file/d/15z4EjMy8wjFYtG3hQ75Kj0DwLG08ozqI/view?usp=sharing"
const sci35GuideLink = "https://drive.google.com/file/d/13kbrJUGV92qM9kuprQIgji9NfFTEOtgg/view?usp=sharing"
const eSci21GuideLink = "https://drive.google.com/file/d/1XCaWgyph70X52GoAa77Ft0gEsofnr2YP/view?usp=sharing"
const sciBioGuideLink = "https://drive.google.com/file/d/1bppy-WQ5tVE-IO7CRaEWTzWJ_rLGis9w/view?usp=sharing"
const sciESSGuideLink = "https://drive.google.com/file/d/1EGuuGBTHP2EtWbEEIl5jaV2ka2hNy9-4/view?usp=sharing"
const hs35GuideLink = "https://drive.google.com/file/d/1zybPK01z90nWrSOGbeTXcyaT7xUoI_Ts/view?usp=drive_link"
const hs68GuideLink = "https://drive.google.com/file/d/1uhRo7V2PfmXarNgxND6jVPoadCtEtWMH/view?usp=drive_link"

const scienceLinks: Record<BlockType, string> = {
    "Science 35": sci35GuideLink,
    "Science 68": sci68GuideLink,
    "Science 21-35": sci2135GuideLink,
    "Science 35 Michigan": "",
    "Science Bio": sciBioGuideLink,
    "Science ESS": sciESSGuideLink,
    "Science 35 NY Grade 3": "",
    "Science 35 NY Grade 4": "",
    "Science 35 NY Grade 5": "",
    "Science 35 National Grade 3": "",
    "Science 35 National Grade 4": "",
    "Science 35 National Grade 5": ""
}

const textbookLinks: Record<TextbookProductType, string> = {
    "eScience21": eSci21GuideLink,
    "homeschool35": hs35GuideLink,
    "homeschool68":hs68GuideLink,
}

const ScienceSupportDocumentsPage = () => {
    const { block, textbookProduct } = useParams() as { block?: string, textbookProduct?: TextbookProductType }
    
    const blockType = toBlockType(block)
    const guideLink = textbookProduct ? textbookLinks[textbookProduct] : blockType ? scienceLinks[blockType] : null

    return (
        <div className="mt-3">
            <h1><i className="fa-solid fa-user-graduate"></i> Supporting Documents</h1>
            <Row className="mt-5">
                <Col xs={12} lg={3}>
                    <Button variant="theme" onClick={() => {
                        window.open(guideLink, "_blank")
                    }}>Step-by-Step Guide</Button>
                </Col>
            </Row>
        </div>
    )
}

export default ScienceSupportDocumentsPage
